import Api from "../axios";

export const getLeaveStatement = async ({ financial_year, employee_id, is_flag }) => {
  return Api.get(
    `/leave_statement?financial_year=${financial_year}&employee_id=${employee_id}&is_flag=${is_flag}`
  );
};
